import { Schema } from "effect";
import { StatisticsValueFromProperties } from "./statistics";
const CursorSchema = Schema.Struct({
    id: Schema.Number,
    archived: Schema.Boolean
});
const CursorUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(CursorSchema));
export const UrlParams = Schema.Struct({
    limit: Schema.NumberFromString.pipe(Schema.optionalWith({
        default: ()=>100
    })),
    cursor: CursorUrlParams.pipe(Schema.optional),
    archived: Schema.BooleanFromString.pipe(Schema.optionalWith({
        default: ()=>false
    }))
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: CursorUrlParams
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
const BaseVariantSchema = Schema.Struct({
    id: Schema.NumberFromString,
    object: Schema.Literal("variant"),
    experimentId: Schema.NumberFromString,
    percentage: Schema.Number
});
const PaywallVariantSchema = BaseVariantSchema.pipe(Schema.extend(Schema.Struct({
    variantType: Schema.Literal("TREATMENT"),
    type: Schema.Literal("PAYWALL"),
    paywallId: Schema.NumberFromString
})));
const HoldoutVariantSchema = BaseVariantSchema.pipe(Schema.extend(Schema.Struct({
    variantType: Schema.Literal("HOLDOUT"),
    type: Schema.Literal("NONE")
})));
const VariantSchema = Schema.Union(PaywallVariantSchema, HoldoutVariantSchema);
export class Audience extends Schema.Class("superwall-api-Campaign-Audience")({
    id: Schema.NumberFromString,
    object: Schema.Literal("audience"),
    campaignId: Schema.NumberFromString,
    experimentId: Schema.NumberFromString,
    expression: Schema.String.pipe(Schema.NullOr),
    variants: Schema.Array(VariantSchema)
}, {
    title: "CampaignAudience"
}) {
}
export class Trigger extends Schema.Class("superwall-api-Campaign-Trigger")({
    id: Schema.NumberFromString,
    object: Schema.Literal("trigger"),
    campaignId: Schema.NumberFromString,
    enabled: Schema.Boolean,
    eventName: Schema.String
}, {
    title: "CampaignTrigger"
}) {
}
export class Model extends Schema.Class("superwall-api-Campaign-Model")({
    id: Schema.NumberFromString,
    object: Schema.Literal("campaign"),
    applicationId: Schema.NumberFromString,
    description: Schema.String.pipe(Schema.NullOr),
    // Audiences
    audiences: Schema.Array(Audience),
    triggers: Schema.Array(Trigger)
}, {
    title: "CampaignModel"
}) {
}
export class List extends Schema.Class("superwall-api-Campaign-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}, {
    title: "CampaignList"
}) {
}
/**
 *   campaignId: string
  paywallUsers: ValueNumber | ValueError
  paywallConvRate: ValuePercentage | ValueError
  transactionCompletes: ValueNumber | ValueError
  grossProceeds: ValueCurrency | ValueError
 */ export class LegacyStatistics extends Schema.Class("superwall-api-Campaign-LegacyStatistics")({
    params: Schema.Any,
    data: Schema.Record({
        key: Schema.String,
        value: Schema.Struct({
            campaignId: Schema.String,
            paywallUsers: StatisticsValueFromProperties,
            paywallConvRate: StatisticsValueFromProperties,
            transactionCompletes: StatisticsValueFromProperties,
            grossProceeds: StatisticsValueFromProperties
        })
    })
}, {
    title: "CampaignLegacyStatistics"
}) {
} /*
 "data": {
            "14830": {
                "campaignId": "14830",
                "paywallUsers": {
                    "type": "number",
                    "value": 13
                },
                "paywallConvRate": {
                    "type": "percentage",
                    "value": 0
                },
                "transactionCompletes": {
                    "type": "number",
                    "value": 0
                },
                "grossProceeds": {
                    "type": "currency",
                    "value": 0
                }
            },
*/ 
